<template>
	<v-row>
		<v-col
			cols="12"
			lg="6"
			offset="0"
			offset-lg="3"
		>
			<pending-orders />
		</v-col>
	</v-row>
</template>

<script>
import PendingOrders from '../../../organisms/PendingOrders.vue';
export default {
	name: 'PendingOrdersPage',
	components: {
		PendingOrders
	}
};
</script>
